export default __webpack_public_path__ + "static/media/1.906c62d6.png";